import { urls } from '../../constants/constants';

const validate = (patientid, departmentId) => {
  return new Promise((resolve, reject) => {
    fetch(
      `${urls.aspariaBackend}api/v1/patient/fileUpload/${departmentId ? departmentId + '/' : ''}${patientid}/validate`,
      {
        headers: {
          method: 'GET',
          Pragma: 'no-cache',
        },
        credentials: 'include',
      }
    )
      .then((data) => {
        return data.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default validate;
